module.exports = __webpack_public_path__ + "img/QRCode-nextshop.821e1b00.svg";